// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cE9pLtgjdIGAsdrs {
  background-color: #fff;
}
.cE9pLtgjdIGAsdrs .aeiLAJ8D3RQwpQjY {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
}
@media (max-width: 768px) {
  .cE9pLtgjdIGAsdrs .aeiLAJ8D3RQwpQjY {
    width: 100vw;
  }
}
.cE9pLtgjdIGAsdrs .yTQRhZZITQRTTZne {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 32px;
}
.cE9pLtgjdIGAsdrs .PtAgSfXwDvskAuq_ {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.cE9pLtgjdIGAsdrs .X2o3VhR9AXmy0Woz {
  font-size: 20px;
  flex-shrink: 0;
}
.cE9pLtgjdIGAsdrs .G1sAlDnFbYY3wLs3 {
  color: #1677ff;
}
.cE9pLtgjdIGAsdrs .aEAPuXPpZcEa5Iuo {
  color: #a855f7;
}
.cE9pLtgjdIGAsdrs .gg1xYzKyvhIhNQQD {
  flex-shrink: 0;
  margin: 0;
  padding: 4px 12px;
  border: 1px solid #1677ff;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.cE9pLtgjdIGAsdrs .gg1xYzKyvhIhNQQD:hover {
  background: #eff6ff;
}
.cE9pLtgjdIGAsdrs .cjIXHkih6QXJKiyD {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay {
  display: flex;
  margin-right: 36px;
  align-items: center;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .XdUWqfqRi_w1MuTT {
  width: 24px;
  height: 24px;
  border-radius: 100%;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .ODK8otCAZ0ecD6lf {
  width: 44px;
  line-height: 20px;
  border-radius: 2px;
  background: rgba(255, 98, 0, 0.1);
  color: #ff6200;
  text-align: center;
  font-size: 12px;
  margin-right: 8px;
  margin-left: -4px;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .w3hiKzkxRIIhhLc_ {
  position: relative;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .w3hiKzkxRIIhhLc_ ._rzqHBtZ7gcDyFT5 {
  position: absolute;
  left: -100%;
  top: 30px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #dfe3e7;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
  transition: 1.3s;
  z-index: 1;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .ehMbwkbiug80fdrd {
  margin-left: 6px;
  color: #666666;
  font-size: 12px;
  position: relative;
  margin-right: 8px;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .oL2Gv9yNRcozYWJn {
  position: absolute;
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  top: 9px;
  right: -10px;
  border-bottom: 1px solid #666;
  border-right: 1px solid #666;
  transform: rotate(45deg);
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .oL2Gv9yNRcozYWJn:hover {
  color: #0095fc;
}
.cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .oL2Gv9yNRcozYWJn:hover::after {
  border-bottom-color: #0095fc;
  border-right-color: #0095fc;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F {
  width: 240px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e8e8e8;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .w95wmveoxgzzCQjj {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .xkZ_GJkLlMQwqz9M {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .vdg0e9lvDlQklH4W {
  flex: 1;
  min-width: 0;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .U43kNzqP34z18ZFc {
  color: #1a1a1a;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .U43kNzqP34z18ZFc span {
  display: inline-block;
  vertical-align: middle;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .Kf4vx4yaqEBxcT6p {
  color: #888;
  line-height: 18px;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  overflow: hidden;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .IkfFAvX3BEQ0EP8u {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  flex-shrink: 0;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .Ew2_C5LapI7t2QMU {
  color: #666;
  font-size: 12px;
  flex-shrink: 0;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .Ew2_C5LapI7t2QMU::before {
  content: "·";
  margin: 0 2px;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .nATnirn6_Pc5Lh4l {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .pk80BdjGwRwXL8Xc {
  color: #999;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .pk80BdjGwRwXL8Xc:hover {
  color: #1677ff;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .S61dG0Yss6AmFN0p {
  padding: 4px 0;
  margin: 0;
  border-top: 1px solid #f0f0f0;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .IrpP5EUdwgUFwM6o {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  cursor: pointer;
  font-size: 13px;
  line-height: 22px;
  padding: 8px 16px;
  transition: all 0.2s;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .IrpP5EUdwgUFwM6o:hover {
  color: #1677ff;
  background: #f5f5f5;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .JkM7lQL6aoAhKIVc {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .bUS5iuGR7j8p2vKO {
  font-size: 14px;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .BC3ggNxdj488jgQK {
  font-size: 12px;
  color: #bbb;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .MTi8YYhF5u8_hf2p {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
  color: #999;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F .MTi8YYhF5u8_hf2p:hover {
  color: #ff4d4f;
  background: #fff1f0;
}
.cE9pLtgjdIGAsdrs .dUE1YwZHZwfPUC0w {
  width: 16px;
  cursor: pointer;
}
.cE9pLtgjdIGAsdrs .QbhSD1YT3k98IAWd {
  color: #0095FC;
}
@media (max-width: 768px) {
  .cE9pLtgjdIGAsdrs .aeiLAJ8D3RQwpQjY {
    width: 100%;
    height: auto;
    min-height: 56px;
    padding: 8px 12px;
    box-sizing: border-box;
    gap: 8px;
  }
  .cE9pLtgjdIGAsdrs .yTQRhZZITQRTTZne {
    margin-left: 0;
    min-width: 0;
    flex: 1;
    gap: 8px;
  }
  .cE9pLtgjdIGAsdrs .cjIXHkih6QXJKiyD {
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .cE9pLtgjdIGAsdrs .gg1xYzKyvhIhNQQD {
    padding: 4px 8px;
  }
  .cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay {
    margin-right: 0;
    flex-shrink: 0;
    max-width: 42%;
  }
  .cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .ehMbwkbiug80fdrd {
    display: inline-block;
    max-width: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  .cE9pLtgjdIGAsdrs .CjhT5assv8ohwLay .w3hiKzkxRIIhhLc_ ._rzqHBtZ7gcDyFT5 {
    left: auto;
    right: 0;
  }
  .cE9pLtgjdIGAsdrs .V4zgvMQN04AiTL2F {
    width: 240px;
  }
}
.bbFFrdmzQT7ikwlV {
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Header/index.modules.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;AAFA;EAGI,aAAA;EAIA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AADJ;AANI;EAAA;IACE,YAAA;EASJ;AACF;AAfA;EAcI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAIJ;AArBA;EAoBI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAIJ;AA3BA;EA0BI,eAAA;EACA,cAAA;AAIJ;AA/BA;EA8BI,cAAA;AAIJ;AAlCA;EAiCI,cAAA;AAIJ;AArCA;EAoCI,cAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;AAIJ;AAFI;EACE,mBAAA;AAIN;AAtDA;EAsDI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAGJ;AA9DA;EA8DI,aAAA;EACA,kBAAA;EACA,mBAAA;AAGJ;AAnEA;EAmEM,WAAA;EACA,YAAA;EACA,mBAAA;AAGN;AAxEA;EAwEM,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAGN;AAnFA;EAmFM,kBAAA;AAGN;AAtFA;EAqFQ,kBAAA;EACA,WAAA;EACA,SAAA;EAGA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8CAAA;EACA,gBAAA;EACA,UAAA;AAER;AAlGA;EAgHM,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAXN;AAzGA;EAuHM,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;AAXN;AAYM;EACE,cAAA;AAVR;AAWQ;EACE,4BAAA;EACA,2BAAA;AATV;AA5HA;EA2II,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0CAAA;EACA,gBAAA;AAZJ;AArIA;EAoJM,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;AAZN;AA3IA;EA2JM,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAbN;AAlJA;EAmKM,OAAA;EACA,YAAA;AAdN;AAtJA;EAwKM,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAfN;AA5JA;EA6KQ,qBAAA;EACA,sBAAA;AAdR;AAhKA;EAmLM,WAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAhBN;AA3KA;EA+LM,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAjBN;AAjLA;EAsMM,WAAA;EACA,eAAA;EACA,cAAA;AAlBN;AAoBM;EACE,YAAA;EACA,aAAA;AAlBR;AA1LA;EAiNM,gBAAA;EACA,uBAAA;EACA,mBAAA;AApBN;AA/LA;EAuNM,WAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArBN;AAuBM;EACE,cAAA;AArBR;AA5MA;EAsOM,cAAA;EACA,SAAA;EACA,6BAAA;AAvBN;AAjNA;EA4OM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAxBN;AA0BM;EACE,cAAA;EACA,mBAAA;AAxBR;AAhOA;EA6PM,aAAA;EACA,mBAAA;EACA,QAAA;AA1BN;AArOA;EAmQM,eAAA;AA3BN;AAxOA;EAuQM,eAAA;EACA,WAAA;AA5BN;AA5OA;EA4QM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AA7BN;AA+BM;EACE,cAAA;EACA,mBAAA;AA7BR;AA5PA;EA8RI,WAAA;EAEA,eAAA;AAhCJ;AAhQA;EAmSI,cAAA;AAhCJ;AAmCE;EAAA;IAEI,WAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;IACA,QAAA;EAjCJ;EA0BA;IAWI,cAAA;IACA,YAAA;IACA,OAAA;IACA,QAAA;EAlCJ;EAoBA;IAkBI,eAAA;IACA,gBAAA;IACA,uBAAA;EAnCJ;EAeA;IAwBI,gBAAA;EApCJ;EAYA;IA4BI,eAAA;IACA,cAAA;IACA,cAAA;EArCJ;EAOA;IAiCM,qBAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EArCN;EADA;IA2CQ,UAAA;IACA,QAAA;EAvCR;EALA;IAkDI,YAAA;EA1CJ;AACF;AA+CA;EACE,mBAAA;AA7CF","sourcesContent":[".headerContainer {\n  background-color: #fff;\n  .header {\n    width: 1200px;\n    @media (max-width: 768px) {\n      width: 100vw;\n    }\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 56px;\n  }\n  .titleArea {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-left: 32px;\n  }\n  .brandGroup {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n  .brandIcon {\n    font-size: 20px;\n    flex-shrink: 0;\n  }\n  .brandIconCn {\n    color: #1677ff;\n  }\n  .brandIconIntl {\n    color: #a855f7;\n  }\n  .workspaceSwitchBtn {\n    flex-shrink: 0;\n    margin: 0;\n    padding: 4px 12px;\n    border: 1px solid #1677ff;\n    border-radius: 4px;\n    background: #fff;\n    color: #1677ff;\n    font-size: 12px;\n    line-height: 20px;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background: #eff6ff;\n    }\n  }\n  .title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    color: #1f2937;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n  }\n  .infoWrapper {\n    display: flex;\n    margin-right: 36px;\n    align-items: center;\n\n    .headerIcon {\n      width: 24px;\n      height: 24px;\n      border-radius: 100%;\n    }\n    .unverified {\n      width: 44px;\n      line-height: 20px;\n      border-radius: 2px;\n      background: rgba(255, 98, 0, 0.1);\n      color: #ff6200;\n      text-align: center;\n      font-size: 12px;\n      margin-right: 8px;\n      margin-left: -4px;\n    }\n    .info {\n      position: relative;\n      .logoutbox {\n        position: absolute;\n        left: -100%;\n        top: 30px;\n        // width: 80px;\n        // height: 34px;\n        border-radius: 8px;\n        background: #ffffff;\n        box-sizing: border-box;\n        border: 1px solid #dfe3e7;\n        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);\n        transition: 1.3s;\n        z-index: 1;\n        // &Info {\n        //     display: inline-block;\n        //     cursor: pointer;\n        //     width: 100%;\n        //     text-align: center;\n        //     color: #666666;\n        //     font-size: 12px;\n        //     line-height: 34px;\n        //     &:hover {\n        //         color: #0095FC;\n        //     }\n        // }\n      }\n    }\n    .infoName {\n      margin-left: 6px;\n      color: #666666;\n      font-size: 12px;\n      position: relative;\n      margin-right: 8px;\n    }\n    .icon {\n      position: absolute;\n      content: \"\";\n      display: inline-block;\n      width: 5px;\n      height: 5px;\n      top: 9px;\n      right: -10px;\n      border-bottom: 1px solid #666;\n      border-right: 1px solid #666;\n      transform: rotate(45deg);\n      &:hover {\n        color: #0095fc;\n        &::after {\n          border-bottom-color: #0095fc;\n          border-right-color: #0095fc;\n        }\n      }\n    }\n  }\n  .userInfo {\n    width: 240px;\n    border-radius: 8px;\n    background: #ffffff;\n    box-sizing: border-box;\n    border: 1px solid #e8e8e8;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n\n    .profileSection {\n      display: flex;\n      align-items: flex-start;\n      gap: 12px;\n      padding: 16px;\n    }\n\n    .avar {\n      width: 48px;\n      height: 48px;\n      border-radius: 50%;\n      object-fit: cover;\n      flex-shrink: 0;\n    }\n\n    .profileDetail {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .name {\n      color: #1a1a1a;\n      font-size: 14px;\n      line-height: 20px;\n      font-weight: 600;\n      span {\n        display: inline-block;\n        vertical-align: middle;\n      }\n    }\n\n    .cp {\n      color: #888;\n      line-height: 18px;\n      font-size: 12px;\n      margin-top: 4px;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      flex-wrap: nowrap;\n      overflow: hidden;\n    }\n\n    .mfrIcon {\n      width: 16px;\n      height: 16px;\n      vertical-align: middle;\n      flex-shrink: 0;\n    }\n\n    .identityTag {\n      color: #666;\n      font-size: 12px;\n      flex-shrink: 0;\n\n      &::before {\n        content: \"·\";\n        margin: 0 2px;\n      }\n    }\n\n    .vendorText {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .qid {\n      color: #999;\n      font-size: 12px;\n      line-height: 18px;\n      margin-top: 4px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      &:hover {\n        color: #1677ff;\n      }\n    }\n\n    .actionList {\n      padding: 4px 0;\n      margin: 0;\n      border-top: 1px solid #f0f0f0;\n    }\n\n    .actionItem {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      color: #333;\n      cursor: pointer;\n      font-size: 13px;\n      line-height: 22px;\n      padding: 8px 16px;\n      transition: all 0.2s;\n\n      &:hover {\n        color: #1677ff;\n        background: #f5f5f5;\n      }\n    }\n\n    .actionLabel {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .actionIcon {\n      font-size: 14px;\n    }\n\n    .actionArrow {\n      font-size: 12px;\n      color: #bbb;\n    }\n\n    .logoutSection {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      padding: 10px 16px;\n      border-top: 1px solid #f0f0f0;\n      color: #999;\n      font-size: 13px;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:hover {\n        color: #ff4d4f;\n        background: #fff1f0;\n      }\n    }\n  }\n  .copy {\n    width: 16px;\n    \n    cursor: pointer;\n  }\n  .copiedAppid {\n    color:#0095FC;\n  }\n\n  @media (max-width: 768px) {\n    .header {\n      width: 100%;\n      height: auto;\n      min-height: 56px;\n      padding: 8px 12px;\n      box-sizing: border-box;\n      gap: 8px;\n    }\n\n    .titleArea {\n      margin-left: 0;\n      min-width: 0;\n      flex: 1;\n      gap: 8px;\n    }\n\n    .title {\n      font-size: 15px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .workspaceSwitchBtn {\n      padding: 4px 8px;\n    }\n\n    .infoWrapper {\n      margin-right: 0;\n      flex-shrink: 0;\n      max-width: 42%;\n\n      .infoName {\n        display: inline-block;\n        max-width: 72px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        vertical-align: middle;\n      }\n\n      .info {\n        .logoutbox {\n          left: auto;\n          right: 0;\n        }\n      }\n    }\n\n    .userInfo {\n      width: min(240px, calc(100vw - 24px));\n    }\n  }\n\n}\n\n.permAlert {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `cE9pLtgjdIGAsdrs`,
	"header": `aeiLAJ8D3RQwpQjY`,
	"titleArea": `yTQRhZZITQRTTZne`,
	"brandGroup": `PtAgSfXwDvskAuq_`,
	"brandIcon": `X2o3VhR9AXmy0Woz`,
	"brandIconCn": `G1sAlDnFbYY3wLs3`,
	"brandIconIntl": `aEAPuXPpZcEa5Iuo`,
	"workspaceSwitchBtn": `gg1xYzKyvhIhNQQD`,
	"title": `cjIXHkih6QXJKiyD`,
	"infoWrapper": `CjhT5assv8ohwLay`,
	"headerIcon": `XdUWqfqRi_w1MuTT`,
	"unverified": `ODK8otCAZ0ecD6lf`,
	"info": `w3hiKzkxRIIhhLc_`,
	"logoutbox": `_rzqHBtZ7gcDyFT5`,
	"infoName": `ehMbwkbiug80fdrd`,
	"icon": `oL2Gv9yNRcozYWJn`,
	"userInfo": `V4zgvMQN04AiTL2F`,
	"profileSection": `w95wmveoxgzzCQjj`,
	"avar": `xkZ_GJkLlMQwqz9M`,
	"profileDetail": `vdg0e9lvDlQklH4W`,
	"name": `U43kNzqP34z18ZFc`,
	"cp": `Kf4vx4yaqEBxcT6p`,
	"mfrIcon": `IkfFAvX3BEQ0EP8u`,
	"identityTag": `Ew2_C5LapI7t2QMU`,
	"vendorText": `nATnirn6_Pc5Lh4l`,
	"qid": `pk80BdjGwRwXL8Xc`,
	"actionList": `S61dG0Yss6AmFN0p`,
	"actionItem": `IrpP5EUdwgUFwM6o`,
	"actionLabel": `JkM7lQL6aoAhKIVc`,
	"actionIcon": `bUS5iuGR7j8p2vKO`,
	"actionArrow": `BC3ggNxdj488jgQK`,
	"logoutSection": `MTi8YYhF5u8_hf2p`,
	"copy": `dUE1YwZHZwfPUC0w`,
	"copiedAppid": `QbhSD1YT3k98IAWd`,
	"permAlert": `bbFFrdmzQT7ikwlV`
};
export default ___CSS_LOADER_EXPORT___;
